<template>
    <div class="checkbox">
        <label :for="`checkbox__${name}`" class="checkbox__label">{{ label }}</label>

        <label class="checkbox__wrapper">
            <input type="checkbox" class="checkbox__input" :id="`checkbox__${name}`" v-model="value">
            <span class="checkbox__slider"></span>
        </label>
    </div>
</template>

<script>
export default {
    name: "InputCheckbox",
    props: {
        name: {
            type: String
        },
        label: {
            type: String,
        },
        data: {
            type: Boolean
        }
    },    
    data() {
        return {
            value: false
        };
    },
    watch: {
        value(val) {
            this.$emit("setCheckboxValue", val);
        }
    },
    mounted() {
        this.value = this.data;
    },
    updated() {
        this.value = this.data;
    }    
};
</script>